import * as styles from './Warning.module.css'

import React from 'react'

interface Props {
  children: React.ReactNode
}

export const Warning: React.FC<Props> = (props) => {
  const { children } = props

  return <div className={styles.container}>{children}</div>
}
